<template>
    <component :is="assignComponent()" :to="routerLink" class="uik-top-bar-link__wrapper">
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: "UikTopBarLink",
    props: {
        component: { type: String, default: "a" },
        routerLink: {
            type: String,
            default: ""
        }
    },
    methods: {
        assignComponent () {
            if (this.routerLink !== "") {
                return "router-link"
            }
            return "a"
        }
    }
}
</script>

<style lang="scss">
.uik-top-bar-link__wrapper {
  height: 38px;
  line-height: 38px;
  padding: 0 15px;
  display: block;
  cursor: pointer;
  font-size: .875rem;
  color: $textMain;
  white-space: nowrap;
  &:hover,
  &:global(.active) {
    color: $primary;
  }
  @media only screen and (max-width: 500px) {
    padding: 0 6px;
    font-size: .85rem;
  }
}
.router-link-active {
  color: $primary;
  font-weight: 500;
}
</style>
